import React from 'react';
import { graphql } from 'gatsby';
import SEO from '../components/SEO';
import ReadyToStartCTA from '../components/CTA/ReadyToStart';
import SiteLayout from '../components/SiteLayout';
import Hero from '../components/Solutions/Hero';
import ContentBlocks from '../components/Solutions/ContentBlocks';
import { StyledCTA } from '../components/Solutions/styles';

const Tier1Template = ({
  location,
  data: {
    wpgraphql: {
      pageBy: {
        acfSolutionsTier1And2: { hero, contentBlocks },
        ...page
      },
    },
  },
}) => (
  <SiteLayout location={location}>
    <SEO page={page} path={location.pathname} />
    <Hero hero={hero} />
    <ContentBlocks blocks={contentBlocks} />
    <StyledCTA>
      <ReadyToStartCTA />
    </StyledCTA>
  </SiteLayout>
);

export default Tier1Template;

export const query = graphql`
  query GET_TIER0($id: ID!) {
    wpgraphql {
      pageBy(id: $id) {
        uri
        ...SEOPageFragment
        ...HeroFragment
        ...MediaAndTextFragment
        ...TypesOfPackagesFragment
        ...TabbedCodeExamplesFragment
        ...FeaturesFragment
        ...IconCardsFragment
        ...StatisticsFragment
        ...CalloutColumnsFragment
        ...FrequentlyAskedQuestionsFragment
        ...ContactFormTier1And2Fragment
      }
    }
  }
`;
